import InputMask from "react-input-mask";
import querySearch from "stringquery";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import TagManager from "react-gtm-module";
import { yupResolver } from "@hookform/resolvers/yup";
import { Checkbox, Error } from "../../styles/global";
import { StatesArray } from "../PersonalData/utils";
import { schema, invalidCpf } from "../PersonalData/validations";
import Options from "../../components/Options";
import Button from "../../components/Button";
import Email from "../../components/Email";
import HiddenInputs from "../../components/HiddenInputs";

import { Container, Form, Input, InputContainer } from "./style";

const PersonalData = ({ email, setEmail, formId }) => {
  const url = "https://kenzie39049.activehosted.com/proc.php";

  const location = useLocation();

  const { register, errors, watch, setError, clearErrors } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    const urlParams = querySearch(location.search);

    if (urlParams.frontend_tag) {
      localStorage.setItem("frontendTag", "active");
    }

    TagManager.dataLayer({
      dataLayer: { event: "lead-inscricao" },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [states, setStates] = useState([]);

  const sort = (a, b) => {
    if (a.nome > b.nome) {
      return 1;
    }
    if (a.nome < b.nome) {
      return -1;
    }

    return 0;
  };

  useEffect(() => {
    const sortedStates = StatesArray.sort((a, b) => sort(a, b));
    setStates(sortedStates);
  }, []);

  const firstName = watch(["firstname"]).firstname;
  const lastName = watch(["lastname"]).lastname;
  const gender = watch(["field[199]"])["field[199]"];
  const birthDate = watch(["field[16]"])["field[16]"];
  const city = watch(["field[20]"])["field[20]"];
  const state = watch(["field[21]"])["field[21]"];
  const schooling = watch(["field[24]"])["field[24]"];
  const skinColor = watch(["field[119]"])["field[119]"];
  const familyIncomes = watch(["field[26]"])["field[26]"];
  const preferredName = watch(["field[155]"])["field[155]"];

  const [phoneValue, setPhoneValue] = useState("");
  const [cpfValue, setCpfValue] = useState("");

  const areaUndefined = schooling === undefined;

  const showArea =
    (!areaUndefined && schooling.includes("Superior")) ||
    (!areaUndefined && schooling.includes("Especialização"));

  const validateEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const submitData = (e) => {
    const fullname = `${firstName} ${lastName}`;

    if (
      String(firstName || "").trim().length === 0 ||
      String(lastName || "").trim().length === 0 ||
      preferredName === "" ||
      gender === null ||
      birthDate === "" ||
      phoneValue === "" ||
      phoneValue.length > 15 ||
      cpfValue === "" ||
      cpfValue.length > 14 ||
      city === "" ||
      state === "" ||
      schooling === "" ||
      skinColor === "" ||
      familyIncomes === "" ||
      email === "" ||
      !validateEmail.test(email)
    ) {
      e.preventDefault();

      if (validateEmail.test(email) === false) {
        setError("email", {
          message: "O e-mail deve ser formatado corretamente",
        });
      }

      if (email === "") {
        setError("email", { message: "Preencha esse campo obrigatório." });
      }

      if (String(firstName).trim().length === 0) {
        setError("firstname", {
          message: "Preencha este campo obrigatório com um nome válido.",
        });
      }

      if (firstName === "") {
        setError("firstname", { message: "Preencha este campo obrigatório." });
      }

      if (String(lastName).trim().length === 0) {
        setError("lastname", {
          message: "Preencha este campo obrigatório com um sobrenome válido.",
        });
      }

      if (lastName === "") {
        setError("lastname", { message: "Preencha este campo obrigatório." });
      }

      if (preferredName === "") {
        setError("preferredName", {
          message: "Preencha este campo obrigatório.",
        });
      }

      if (gender === null) {
        setError("gender", { message: "Preencha este campo obrigatório." });
      }

      if (birthDate === "") {
        setError("birthDate", { message: "Preencha este campo obrigatório." });
      }

      if (phoneValue !== undefined && phoneValue === "") {
        setError("phone", { message: "Preencha este campo obrigatório." });
      }

      if (phoneValue !== undefined && phoneValue.length > 15) {
        setError("phone", { message: "Deve conter apenas 11 números." });
      }

      if (cpfValue === "") {
        setError("cpf", { message: "Preencha este campo obrigatório." });
      }

      if (cpfValue.length > 14) {
        setError("cpf", { message: "Deve conter apenas 11 números." });
      }

      if (invalidCpf.includes(cpfValue)) {
        setError("cpf", { message: "CPF inválido" });
      }

      if (city === "") {
        setError("city", { message: "Preencha este campo obrigatório." });
      }

      if (state === "") {
        setError("state", { message: "Preencha este campo obrigatório." });
      }

      if (skinColor === "") {
        setError("skinColor", { message: "Preencha este campo obrigatório." });
      }

      if (familyIncomes === "") {
        setError("familyIncomes", {
          message: "Preencha este campo obrigatório.",
        });
      }

      if (schooling === "") {
        setError("schooling", {
          message: "Preencha este campo obrigatório.",
        });
      }

      return false;
    }

    localStorage.setItem("email", email);
    localStorage.setItem("fullname", fullname);
    return true;
  };

  useEffect(() => {
    if (firstName !== "" && String(firstName).trim().length !== 0) {
      clearErrors("firstname");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName]);

  useEffect(() => {
    if (lastName !== "" && String(lastName).trim().length !== 0) {
      clearErrors("lastname");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastName]);

  useEffect(() => {
    if (preferredName !== "") {
      clearErrors("preferredName");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preferredName]);

  useEffect(() => {
    if (gender !== null) {
      clearErrors("gender");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gender]);

  useEffect(() => {
    if (birthDate !== "") {
      clearErrors("birthDate");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [birthDate]);

  useEffect(() => {
    if (
      phoneValue !== undefined &&
      phoneValue !== "" &&
      phoneValue.length === 15
    ) {
      clearErrors("phone");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneValue]);

  useEffect(() => {
    if (
      cpfValue !== undefined &&
      cpfValue !== "" &&
      cpfValue.length === 14 &&
      !invalidCpf.includes(cpfValue)
    ) {
      clearErrors("cpf");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cpfValue]);

  useEffect(() => {
    if (city !== "") {
      clearErrors("city");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city]);

  useEffect(() => {
    if (state !== "") {
      clearErrors("state");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    if (skinColor !== "") {
      clearErrors("skinColor");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skinColor]);

  useEffect(() => {
    if (familyIncomes !== "") {
      clearErrors("familyIncomes");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [familyIncomes]);

  useEffect(() => {
    if (schooling !== "") {
      clearErrors("schooling");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schooling]);

  useEffect(() => {
    if (email !== "") {
      clearErrors("email");
    }

    if (validateEmail.test(email)) {
      clearErrors("email");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <>
      <Container id="main">
        <Form onSubmit={submitData} method="POST" action={url} validate>
          <HiddenInputs formId={formId} />

          <Email
            name="email"
            value={email}
            error={errors.email?.message}
            onChange={setEmail}
          />

          <h2>Sobre você</h2>
          <InputContainer>
            <Input>
              <label>
                Nome
                <input ref={register} name="firstname" />
              </label>
              <Error>{errors.firstname?.message}</Error>
            </Input>

            <Input>
              <label>
                Sobrenome
                <input ref={register} name="lastname" />
              </label>
              <Error>{errors.lastname?.message}</Error>
            </Input>
          </InputContainer>

          <Input>
            <label>
              Como deseja ser chamado(a)?
              <input ref={register} name="field[155]" />
            </label>
            <Error>{errors.preferredName?.message}</Error>
          </Input>

          <Options>
            <legend>Gênero</legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Feminino"
                />{" "}
                Feminino
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Masculino"
                />{" "}
                Masculino
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Transgênero"
                />{" "}
                Transgênero
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Não binário"
                />{" "}
                Não binário
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Prefiro não declarar"
                />{" "}
                Prefiro não declarar
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Outro"
                />{" "}
                Outro
              </label>
            </Checkbox>
            <Error>{errors.gender?.message}</Error>
          </Options>

          <InputContainer>
            <Input>
              <label>
                Data Nascimento
                <input
                  type="date"
                  ref={register}
                  name="field[16]"
                  placeholder="dd-mm-yyyy"
                />
              </label>
              <Error>{errors.birthDate?.message}</Error>
            </Input>

            <Input>
              <label>
                Telefone Celular (com DDD)
                <InputMask
                  placeholder="41999999999"
                  mask="(99) 99999-9999"
                  maskChar=""
                  name="phone"
                  value={phoneValue}
                  onChange={(e) => setPhoneValue(e.target.value)}
                />
              </label>
              <Error>{errors.phone?.message}</Error>
            </Input>
          </InputContainer>

          <Input>
            <label>
              CPF (apenas os números)
              <InputMask
                mask="999.999.999-99"
                name="field[22]"
                value={cpfValue}
                onChange={(e) => setCpfValue(e.target.value)}
              />
            </label>
            <Error>{errors.cpf?.message}</Error>
          </Input>

          <InputContainer>
            <Input>
              <label>
                Cidade
                <input ref={register} name="field[20]" />
              </label>
              <Error>{errors.city?.message}</Error>
            </Input>

            {
              <Input>
                <label>
                  Estado
                  <select ref={register} name="field[21]">
                    <option value="">Selecione</option>
                    {states.map((state, index) => (
                      <option key={index} value={state.nome}>
                        {state.nome}
                      </option>
                    ))}
                  </select>
                </label>
                <Error>{errors.state?.message}</Error>
              </Input>
            }
          </InputContainer>

          <Input>
            <label>
              Qual o valor total somando a renda de todas as pessoas que moram
              na sua casa?
              <select ref={register} name="field[26]">
                <option selected></option>
                <option value="Sem renda no momento">
                  Sem renda no momento
                </option>
                <option value="Até 1000 reais">Até 1000 reais</option>
                <option value="Entre 1001 e 2000 reais">
                  Entre 1001 e 2000 reais
                </option>
                <option value="Entre 2001 e 3000 reais">
                  Entre 2001 e 3000 reais
                </option>
                <option value="Entre 3001 e 4000 reais">
                  Entre 3001 e 4000 reais
                </option>
                <option value="Entre 4001 e 5000 reais">
                  Entre 4001 e 5000 reais
                </option>
                <option value="Mais de 5000 reais">Mais de 5000 reais</option>
              </select>
            </label>
            <Error>{errors.familyIncomes?.message}</Error>
          </Input>

          <Input>
            <label>
              Cor ou raça, escolha qual você se identifica?
              <select ref={register} name="field[119]">
                <option selected></option>
                <option value="Branca">Branca</option>
                <option value="Preta">Preta</option>
                <option value="Parda">Parda</option>
                <option value="Indígena">Indígena</option>
                <option value="Oriental">Oriental</option>
              </select>
            </label>
            <Error>{errors.skinColor?.message}</Error>
          </Input>

          <Input>
            <label>
              Qual a sua escolaridade?
              <select ref={register} name="field[24]">
                <option selected> </option>
                <option value="Ensino Médio Incompleto">
                  Ensino Médio Incompleto
                </option>
                <option value="Ensino Médio Completo">
                  Ensino Médio Completo
                </option>
                <option value="Ensino Superior Cursando">
                  Ensino Superior Cursando
                </option>
                <option value="Ensino Superior Incompleto">
                  Ensino Superior Incompleto
                </option>
                <option value="Ensino Superior Completo">
                  Ensino Superior Completo
                </option>
                <option value="Pós-Graduação/Especialização">
                  Pós-Graduação/Especialização
                </option>
              </select>
            </label>
            <Error>{errors.schooling?.message}</Error>
          </Input>

          {showArea && (
            <Input>
              <label>
                Área de Formação
                <select ref={register} name="field[29]">
                  <option value="">Selecione</option>
                  <option value="Administração">Administração</option>
                  <option value="Ciências da Computação">
                    Ciências da Computação
                  </option>
                  <option value="Sistemas de Informação">
                    Sistemas de Informação
                  </option>
                  <option value="Direito">Direito</option>
                  <option value="Engenharias">Engenharias</option>
                  <option value="Economia/Finanças">Economia/Finanças</option>
                  <option value="Exatas (Mateḿatica, Física, ... )">
                    Exatas (Mateḿatica, Física, ... )
                  </option>
                  <option value="Biológicas (Medicina, Psicologia, ... )">
                    Biológicas (Medicina, Psicologia, ... )
                  </option>
                  <option value="Humanas (Letras, Pedagogia, ... )">
                    Humanas (Letras, Pedagogia, ... )
                  </option>
                  <option value="Outros">Outros</option>
                </select>
              </label>
              <Error>{errors.area?.message}</Error>
            </Input>
          )}

          <Options>
            <legend>Como você conheceu a Kenzie Academy Brasil?</legend>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Instagram"
                  name="field[200]"
                />
                Instagram
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Facebook"
                  name="field[200]"
                />
                Facebook
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="LinkedIn"
                  name="field[200]"
                />
                LinkedIn
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="TikTok"
                  name="field[200]"
                />
                TikTok
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Youtube"
                  name="field[200]"
                />
                Youtube
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Em site de buscas (Google, Bing,...)"
                  name="field[200]"
                />
                Em site de buscas (Google, Bing,...)
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Indicação de conhecidos"
                  name="field[200]"
                />
                Indicação de conhecidos
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Imprensa"
                  name="field[200]"
                />
                Imprensa
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Twitch"
                  name="field[200]"
                />
                Twitch
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Influenciadores"
                  name="field[200]"
                />
                Influenciadores
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Telegram"
                  name="field[200]"
                />
                Telegram
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  value="Outro"
                  name="field[200]"
                />
                Outro
              </label>
            </Checkbox>

            <Error>{errors.howKnew?.message}</Error>
          </Options>

          {Object.keys(errors).length !== 0 && (
            <p>Preencha todos os campos obrigatórios</p>
          )}

          <Button type="submit">Continuar</Button>
        </Form>
      </Container>
    </>
  );
};

export default PersonalData;
